export default class Video {
    constructor(element = null) {
        if (!element) return;

        this.video = element;
        this.controls = this.video.nextElementSibling.classList.contains('video-controls') ? this.video.nextElementSibling : null;
        this.muteBtn = this.controls ? this.controls.querySelector('.mute-control') : null;
        this.pauseBtn = this.controls ? this.controls.querySelector('.pause-control') : null;

        this.events();
    }

    pauseVideo() {
        if (!this.video.paused) {
            this.video.pause();
            this.pauseBtn.querySelector('.icon').classList.add('stop');
        }
    }

    unpauseVideo() {
        if (this.video.paused) {
            this.video.play();
            this.pauseBtn.querySelector('.icon').classList.remove('stop');
        }
    }

    observeVideo() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setTimeout(() => {
                    if (!entry.isIntersecting) {
                        this.video.classList.remove('is-in-view');
                        this.pauseVideo.bind(this)();
                    } else {
                        this.video.classList.add('is-in-view');
                        this.unpauseVideo.bind(this)();
                    }
                }, 500);
            });
        }, {});
    
        observer.observe(this.video);
    }

    onPauseBtnClick(ev) {
        if (this.video.paused) {
            this.unpauseVideo.bind(this)();
        } else {
            this.pauseVideo.bind(this)();
        }
    }

    onMuteBtnClick(ev) {
        if (this.video.muted) {
            this.muteBtn.querySelector('.icon').classList.add('stop');
        } else {
            this.muteBtn.querySelector('.icon').classList.remove('stop');
        }
        this.video.muted = !this.video.muted;
    }

    onWindowLoad(ev) {
        let hidden, visibilityState, visibilityChange;

        if (typeof document.hidden !== "undefined") {
            hidden = "hidden", visibilityChange = "visibilitychange", visibilityState = "visibilityState";
        }
        else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden", visibilityChange = "mozvisibilitychange", visibilityState = "mozVisibilityState";
        }
        else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden", visibilityChange = "msvisibilitychange", visibilityState = "msVisibilityState";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden", visibilityChange = "webkitvisibilitychange", visibilityState = "webkitVisibilityState";
        }

        document.addEventListener(visibilityChange, () => {
            // console.log("hidden: " + document[hidden]);
            // console.log(document[visibilityState]);

            switch (document[visibilityState]) {
            case "visible":
                if (this.video.classList.contains('is-in-view')) {
                    this.unpauseVideo.bind(this)();
                }
                break;
            case "hidden":
                this.pauseVideo.bind(this)();
                break;
            }
        });
    }

    onMainMenuOpen(ev) {
        this.pauseVideo.bind(this)();
    }

    onMainMenuClose(ev) {
        this.unpauseVideo.bind(this)();
    }

    onPreloadComplete(ev) {
        this.unpauseVideo.bind(this)();
        this.observeVideo.bind(this)();
    }

    events() {
        if (this.pauseBtn) {
            this.pauseBtn.addEventListener('click', this.onPauseBtnClick.bind(this), false);
        }

        if (this.muteBtn) {
            this.muteBtn.addEventListener('click', this.onMuteBtnClick.bind(this), false);
        }

        window.addEventListener('load', this.onWindowLoad.bind(this), false);
        window.addEventListener('mainMenu.open', this.onMainMenuOpen.bind(this), false);
        window.addEventListener('mainMenu.close', this.onMainMenuClose.bind(this), false);
        window.addEventListener('preloader.completed', this.onPreloadComplete.bind(this), false);
    }
}